import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { OfferSignatureRequested } from '../models/offer-signature-requested';
import { FilterSignatures } from '../models/filters/filter-signatures';

@Injectable({
  providedIn: 'root'
})
export class RequestedSignaturesService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/signaturesReq'; 

  findAllPageableSignaturesReq(filterSignatures: FilterSignatures, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterSignatures);
  }

  findRequestedSignatureById(id: number): Observable<OfferSignatureRequested> {
    return this.http.get<OfferSignatureRequested>(`${this.url}/${id}`);
  }

  updateOfferSignatureRequested(offerSignatureRequested: OfferSignatureRequested): Observable<OfferSignatureRequested>{
    return this.http.put<OfferSignatureRequested>(`${this.url}/${offerSignatureRequested.id}`, offerSignatureRequested);
  }
  
}
